<template>
  <div>
    <div @click="show = true" class="kefu"></div>
    <div v-if="show" class="total">
      <div class="common2">
        <contact :showImg="false">
          <div @click="show = false" class="close"></div>
        </contact>
      </div>
    </div>
  </div>
</template>
<script>
import contact from "../components/contact.vue";
export default {
  name: "", //
  data() {
    return {
      show: false,
    };
  },
  components: { contact },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
      },
    },
  },
  props: {},
  methods: {},
  created() {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
/* by wdl */
.kefu {
  width: 45px;
  height: 45px;
  background: url("../assets/images/kefu2.png");
  background-size: 100% 100%;
  position: fixed;
  right: 0;
  top: 81%;
}
.total {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  .common2 {
    background: #fff;
    box-shadow: 0px 2px 5px 0px #a7d7fb;
    width: 359px;
    margin: 15px auto 0;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px 10px 15px;
    position: absolute;
    top: calc(50% - 85px);
    left: 0;
    right: 0;
    margin: 0 auto;
    .close {
      background: url("../assets/images/close.png");
      background-size: 100% 100%;
      width: 20px;
      height: 20px;
      margin-left: auto;
      margin-right: 0;
    }
  }
}
</style>
